import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=64d6a7f0&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=js"
export * from "./goodsDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=64d6a7f0&prod&lang=scss&scoped=true"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=64d6a7f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6a7f0",
  null
  
)

export default component.exports